import React, { useContext } from 'react';
import { CartContext } from '../context/CartContext';
import { useNavigate } from 'react-router-dom';
import { FiTrash2, FiShoppingBag } from 'react-icons/fi';

const Cart = () => {
  const { cart, updateCartItem, removeFromCart, getCartTotal } = useContext(CartContext);
  const navigate = useNavigate();

  const handleQuantityChange = (giftCardId, newQuantity) => {
    if (newQuantity < 1) {
      removeFromCart(giftCardId);
    } else {
      updateCartItem(giftCardId, newQuantity);
    }
  };

  const handleCheckout = () => {
    navigate('/checkout');
  };

  if (cart.length === 0) {
    return (
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 text-center">
        <FiShoppingBag className="mx-auto text-gray-400" size={64} />
        <h2 className="text-2xl font-bold mt-4 mb-2">Your cart is empty</h2>
        <p className="text-gray-600 mb-8">Add some gift cards to get started</p>
        <button
          onClick={() => navigate('/catalog')}
          className="bg-primary text-white px-6 py-3 rounded-md hover:bg-blue-600"
        >
          Browse Gift Cards
        </button>
      </div>
    );
  }

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <h1 className="text-4xl font-bold mb-8">Shopping Cart</h1>

      <div className="grid lg:grid-cols-3 gap-8">
        {/* Cart Items */}
        <div className="lg:col-span-2">
          <div className="bg-white rounded-lg shadow-md">
            {cart.map((item) => (
              <div
                key={item.giftCard._id}
                className="p-6 border-b last:border-b-0 flex items-center space-x-4"
              >
                <img
                  src={item.giftCard.image}
                  alt={item.giftCard.name}
                  className="w-24 h-24 object-cover rounded"
                />
                <div className="flex-1">
                  <h3 className="text-lg font-semibold">{item.giftCard.name}</h3>
                  <p className="text-gray-600">{item.giftCard.brand}</p>
                  <p className="text-primary font-semibold mt-2">
                    ${item.giftCard.denominations[0]?.priceUSD || 0}
                  </p>
                </div>
                <div className="flex items-center space-x-2">
                  <button
                    onClick={() => handleQuantityChange(item.giftCard._id, item.quantity - 1)}
                    className="w-8 h-8 bg-gray-200 rounded-md hover:bg-gray-300"
                  >
                    -
                  </button>
                  <span className="w-12 text-center font-semibold">{item.quantity}</span>
                  <button
                    onClick={() => handleQuantityChange(item.giftCard._id, item.quantity + 1)}
                    className="w-8 h-8 bg-gray-200 rounded-md hover:bg-gray-300"
                  >
                    +
                  </button>
                </div>
                <button
                  onClick={() => removeFromCart(item.giftCard._id)}
                  className="text-red-500 hover:text-red-700"
                >
                  <FiTrash2 size={20} />
                </button>
              </div>
            ))}
          </div>
        </div>

        {/* Order Summary */}
        <div className="lg:col-span-1">
          <div className="bg-white rounded-lg shadow-md p-6 sticky top-4">
            <h2 className="text-2xl font-bold mb-4">Order Summary</h2>
            <div className="space-y-2 mb-4">
              <div className="flex justify-between">
                <span className="text-gray-600">Items ({cart.length})</span>
                <span className="font-semibold">${getCartTotal().toFixed(2)}</span>
              </div>
              <div className="flex justify-between text-lg font-bold pt-4 border-t">
                <span>Total</span>
                <span>${getCartTotal().toFixed(2)}</span>
              </div>
            </div>
            <button
              onClick={handleCheckout}
              className="w-full bg-primary text-white py-3 rounded-md hover:bg-blue-600 font-semibold"
            >
              Proceed to Checkout
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Cart;
